import { FC } from 'react';
import styled from 'styled-components/macro';

import { useTheme } from 'hooks/theme';
import { ScButtonProps } from './Button/styled';

export const ButtonPreloader: FC<ScButtonProps> = ({ pending, ...rest }) => {
  const { preloaderDotsAnimation: PreloaderDotsAnimation } = useTheme();

  return !!pending ? (
    <ScButtonPreloader {...rest}>
      <PreloaderDotsAnimation />
    </ScButtonPreloader>
  ) : null;
};

const ScButtonPreloader = styled.div<Omit<ScButtonProps, 'pending'>>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
  svg {
    vertical-align: middle;
    width: 32px;
    height: auto;

    circle {
      fill: ${({ theme }) => theme.whiteColor};
    }
  }
`;
